import React from 'react';
import { Progress } from 'tea-component';

export default function MetricSpecialProgress(props: any) {
  const { percent } = props;
  return (
    <Progress
      // width={54}
      className="dbi-insights-table-progress"
      type="circle"
      percent={percent < 0.01 ? Math.ceil((percent * 10000) / 100) : Math.floor((percent * 10000) / 100)}
      strokeWidth={8}
      strokeColor="#376AE7"
    />
  );
};
